var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeradata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12423_29198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 0.938477C5.4375 0.938477 0.4375 6.58848 0.4375 13.0185C0.4375 19.7685 5.4375 24.9385 12.4375 24.9385C19.4375 24.9385 24.4375 19.7685 24.4375 13.0185C24.4375 6.58848 19.4375 0.938477 12.4375 0.938477ZM8.9075 4.37848H12.4075V7.63848H15.9875V10.4985H12.4075V15.7185C12.4075 17.2985 13.1775 17.9885 14.3375 17.9885C14.7575 17.9885 15.3175 17.8685 15.8475 17.6685C16.2275 18.6685 16.8975 19.5685 17.6175 20.2885C16.5506 20.9175 15.336 21.2522 14.0975 21.2585C10.9775 21.2585 8.9075 19.6085 8.9075 15.9785V4.38848V4.37848Z",
    fill: "#00D08D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12423_29198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.4375 0.938477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeradata);
export default __webpack_public_path__ + "static/media/teradata.31f0a3c379d5428f33e2d35ec787ae8c.svg";
export { ForwardRef as ReactComponent };